import { toast } from 'react-toastify';
import { CONVERSATION_TEMPLATE } from '../config/apiEndPoint';
import { GET, POST, PUT } from 'config/api.config';

export const fetchConversationTemplateTableAndFilterSchema = async (data = {}) => {
    try {
        const url = data?._Id
            ? `${CONVERSATION_TEMPLATE.GET_CONVERSATION_TEMPLATE_SCHEMA}/${data?._Id}`
            : `${CONVERSATION_TEMPLATE.GET_CONVERSATION_TEMPLATE_SCHEMA}`;
        const response = await GET(url, data);
        return response;
    } catch (error) {
        toast.error(error?.message);
    }
};

export const submitConversationTemplateFilterData = async (data = {}) => {
    try {
        const response = await POST(CONVERSATION_TEMPLATE.SUBMIT_FILTER_DATA, data);
        return response;
    } catch (error) {
        toast.error(error?.message);
    }
};

export const getConversationTemplateDefinitions = async (data = {}) => {
    try {
        const response = await GET(CONVERSATION_TEMPLATE.GET_DEFINITIONS, data);
        return response;
    } catch (error) {
        toast.error(error?.message);
    }
};

export const getConversationTemplateById = async (id, data = {}) => {
    try {
        const response = await GET(CONVERSATION_TEMPLATE.GET_CONVERSATION_TEMPLATE_BY_ID(id), data);
        return response;
    } catch (error) {
        toast.error(error?.message);
    }
};

export const addConversationTemplate = async (data = {}) => {
    try {
        const response = await POST(CONVERSATION_TEMPLATE.ADD_CONVERSATION_TEMPLATE, data);
        return response;
    } catch (error) {
        toast.error(error?.message);
    }
};

export const updateConversationTemplate = async (id, data = {}) => {
    try {
        const response = await PUT(CONVERSATION_TEMPLATE.UPDATE_CONVERSATION_TEMPLATE(id), data);
        return response;
    } catch (error) {
        toast.error(error?.message);
    }
};
